import ROUTES from '~/shared/constants/routes.const'

function SomethingWentWrong(): React.ReactElement {
  return (
    <div className="flex h-screen" data-ph-unmask>
      <div className="m-auto">
        <h1>An error has occurred</h1>
        <a href={ROUTES.HOME}>Go Back</a>
      </div>
    </div>
  )
}

export default SomethingWentWrong
